module.exports = __webpack_public_path__ + "static/media/time.41b85ed6.svg";